'use strict';

function sendLineNotifyMessage(options) {
  var query = "?message=" + encodeURIComponent(options.message);

  if (options.image) {
    query += "&image=" + encodeURIComponent(options.image);
  }

  if (process.env.DEV || options.dev) {
    query += "&dev=true=";
  }

  return fetch(process.env.API_SERVER_URL + "/line/notify" + query).then(function (res) {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res;
  });
}

export { sendLineNotifyMessage };